import React from 'react';
import PropTypes from 'prop-types';
import sortingUp from '../../../../../../static/img/blue-asc-sort.svg';
import sortingDown from '../../../../../../static/img/blue-desc-sort.svg';
import sorting from '../../../../../../static/img/sorting.png';
import styles from './UsersInfo.module.less';
import { ColumnHeaders } from '../../constants';

const HeadersBar = (props) => {
  const filteredUsers = props.data?.length;
  const getColumnStyle = (column) => {
    let style = '';
    if (column.id === 'selection') {
      return styles.selectionColumn;
    }

    switch (column.Header) {
      case ColumnHeaders.USERS:
        style = styles.usersColumn;
        break;
      case ColumnHeaders.ADMIN:
        style = styles.adminColumn;
        break;
      case ColumnHeaders.SEARCH:
        style = styles.productColumn;
        break;
      case ColumnHeaders.TEAMS:
        style = styles.teamsColumn;
        break;
      case ColumnHeaders.LAST_LOGIN:
        style = styles.lastLoginColumn;
        break;
      default:
        style = '';
    }

    return style;
  };
  const getNumberOfUsers = (column, totalUsers) => {
    const numOfOrgUsers = totalUsers;

    let num;

    switch (column.Header) {
      case ColumnHeaders.USERS:
        num = numOfOrgUsers;
        break;
      default:
        num = 0;
    }

    return column.Header === ColumnHeaders.USERS ? ` (${num})` : null;
  };
  return props.headerGroups.map((group, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <thead key={`header-${i}`}>
      <tr {...group.getHeaderGroupProps()}>
        {group.headers.map((column) => {
          return (
            <th
              className={getColumnStyle(column)}
              {...column.getHeaderProps(column.getSortByToggleProps())}
              key={column.id}
            >
              {column.Header !== ColumnHeaders.ACTIONS ? column.render('Header') : null}
              {getNumberOfUsers(column, filteredUsers)}
              {column.id !== 'selection' && (
                <span>
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      <img src={sortingUp} alt="" />
                    ) : (
                      <img src={sortingDown} alt="" />
                    )
                  ) : (
                    <img src={sorting} alt="" />
                  )}
                </span>
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  ));
};

HeadersBar.propTypes = {
  headerGroups: PropTypes.array,
  data: PropTypes.array,
};

export default HeadersBar;
